import type { PayCancelResponse, PayStatusResponse } from "~/types/pay";

export const pay = {
  async cancelTransaction(cancelUrl: string) {
    const response = await fetch(cancelUrl, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error("Failed to cancel transaction");
    }

    return response.json() as Promise<PayCancelResponse>;
  },
  async getTransactionStatus(statusUrl: string) {
    const response = await fetch(statusUrl, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error("Failed to fetch transaction status");
    }

    const data = (await response.json()) as PayStatusResponse;

    return {
      timeout: data.status === "start",
      paid: data.status === "final" && data.approved === "1",
      canceled: data.status === "final" && data.cancelled === "1",
    };
  },
};
